const v = "5.3.1";
const fr = 25;
const ip = 0;
const op = 250;
const w = 1080;
const h = 1080;
const nm = "Comp 4";
const ddd = 1;
const assets = [
  {
    id: "comp_0",
    layers: [
      {
        ddd: 0,
        ind: 2,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 75,
                s: [
                  -98,
                  662,
                  0
                ],
                e: [
                  542,
                  666,
                  0
                ],
                to: [
                  106.666664123535,
                  0.66666668653488,
                  0
                ],
                ti: [
                  -106.666664123535,
                  -0.66666668653488,
                  0
                ]
              },
              {
                t: 97
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 75,
        op: 4577,
        st: 75,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 0,
                s: [
                  542,
                  666,
                  0
                ],
                e: [
                  1196,
                  666,
                  0
                ],
                to: [
                  109,
                  0,
                  0
                ],
                ti: [
                  -109,
                  0,
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 0,
        op: 25,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 0,
                s: [
                  1196,
                  666,
                  0
                ],
                e: [
                  1675,
                  666,
                  0
                ],
                to: [
                  79.8333358764648,
                  0,
                  0
                ],
                ti: [
                  -79.8333358764648,
                  0,
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 75,
                s: [
                  1196,
                  666,
                  0
                ],
                e: [
                  1675,
                  666,
                  0
                ],
                to: [
                  79.8333358764648,
                  0,
                  0
                ],
                ti: [
                  -79.8333358764648,
                  0,
                  0
                ]
              },
              {
                t: 97
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 75,
        op: 4577,
        st: 75,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 75,
                s: [
                  542,
                  666,
                  0
                ],
                e: [
                  1196,
                  666,
                  0
                ],
                to: [
                  109,
                  0,
                  0
                ],
                ti: [
                  -109,
                  0,
                  0
                ]
              },
              {
                t: 97
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 75,
        op: 4577,
        st: 75,
        bm: 0
      },
      {
        ddd: 0,
        ind: 7,
        ty: 0,
        nm: "STANDING M 2",
        refId: "comp_7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              1196,
              666,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 25,
        op: 75,
        st: -100,
        bm: 0
      },
      {
        ddd: 0,
        ind: 8,
        ty: 0,
        nm: "CHECK WATCH",
        refId: "comp_8",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              542,
              666,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 25,
        op: 75,
        st: -100,
        bm: 0
      },
      {
        ddd: 0,
        ind: 9,
        ty: 0,
        nm: "STANDING L ",
        refId: "comp_7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              -98,
              662,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 25,
        op: 75,
        st: -100,
        bm: 0
      },
      {
        ddd: 0,
        ind: 10,
        ty: 0,
        nm: "WALK OFF L",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 3,
                s: [
                  -498,
                  666,
                  0
                ],
                e: [
                  -98,
                  662,
                  0
                ],
                to: [
                  66.6666641235352,
                  -0.66666668653488,
                  0
                ],
                ti: [
                  -66.6666641235352,
                  0.66666668653488,
                  0
                ]
              },
              {
                t: 25
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 3,
        op: 25,
        st: 3,
        bm: 0
      },
      {
        ddd: 0,
        ind: 11,
        ty: 0,
        nm: "WALK OFF M",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 2,
                s: [
                  -98,
                  662,
                  0
                ],
                e: [
                  542,
                  666,
                  0
                ],
                to: [
                  106.666664123535,
                  0.66666668653488,
                  0
                ],
                ti: [
                  -106.666664123535,
                  -0.66666668653488,
                  0
                ]
              },
              {
                t: 24
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 2,
        op: 25,
        st: 2,
        bm: 0
      },
      {
        ddd: 0,
        ind: 12,
        ty: 0,
        nm: "STANDING",
        refId: "comp_7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              -98,
              662,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 0,
        op: 2,
        st: -125,
        bm: 0
      },
      {
        ddd: 0,
        ind: 13,
        ty: 4,
        nm: "Shape Layer 1",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              39,
              -96,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              127,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    55.855,
                    55.855
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.572,
                    143.711
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    54.004,
                    9.184
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -290.998,
                    334.513
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 2",
            np: 3,
            cix: 2,
            ix: 2,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    29.914,
                    184.656
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.645,
                    239.812
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 3,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 14,
        ty: 4,
        nm: "Shape Layer 4",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              -518,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -271,
                        153
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        271,
                        -153
                      ]
                    ],
                    v: [
                      [
                        -231,
                        90
                      ],
                      [
                        246,
                        91
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.862745098039,
                    0,
                    0.196078431373,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 18,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 15,
        ty: 4,
        nm: "Shape Layer 2",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              557,
              -96,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              127,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    55.855,
                    55.855
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.572,
                    143.711
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    54.004,
                    9.184
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -290.998,
                    334.513
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 2",
            np: 3,
            cix: 2,
            ix: 2,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    29.914,
                    184.656
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.645,
                    239.812
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 3,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 16,
        ty: 4,
        nm: "Shape Layer 5",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              518,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -271,
                        153
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        271,
                        -153
                      ]
                    ],
                    v: [
                      [
                        -231,
                        90
                      ],
                      [
                        246,
                        91
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.862745098039,
                    0,
                    0.196078431373,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 18,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 17,
        ty: 4,
        nm: "Shape Layer 3",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              540,
              454,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              126,
              126,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -271,
                        153
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        271,
                        -153
                      ]
                    ],
                    v: [
                      [
                        -231,
                        90
                      ],
                      [
                        246,
                        91
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.862745098039,
                    0,
                    0.196078431373,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 18,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 18,
        ty: 0,
        nm: "potted-plant-flat-vector-800x566.jpg Comp 1",
        cl: "jpg",
        refId: "comp_10",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              836,
              634,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              400,
              283,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              77,
              77,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 800,
        h: 566,
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 19,
        ty: 0,
        nm: "potted-plant-flat-vector-800x566.jpg Comp 1",
        cl: "jpg",
        refId: "comp_10",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              256,
              634,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              400,
              283,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              77,
              77,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 800,
        h: 566,
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 22,
        ty: 1,
        nm: "White Solid 2",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              540,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              540,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        ef: [
          {
            ty: 21,
            nm: "Fill",
            np: 9,
            mn: "ADBE Fill",
            ix: 2,
            en: 1,
            ef: [
              {
                ty: 10,
                nm: "Fill Mask",
                mn: "ADBE Fill-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 0,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "All Masks",
                mn: "ADBE Fill-0007",
                ix: 2,
                v: {
                  a: 0,
                  k: 0,
                  ix: 2
                }
              },
              {
                ty: 2,
                nm: "Color",
                mn: "ADBE Fill-0002",
                ix: 3,
                v: {
                  a: 0,
                  k: [
                    0.849969387054,
                    0.936350643635,
                    1,
                    1
                  ],
                  ix: 3
                }
              },
              {
                ty: 7,
                nm: "Invert",
                mn: "ADBE Fill-0006",
                ix: 4,
                v: {
                  a: 0,
                  k: 0,
                  ix: 4
                }
              },
              {
                ty: 0,
                nm: "Horizontal Feather",
                mn: "ADBE Fill-0003",
                ix: 5,
                v: {
                  a: 0,
                  k: 0,
                  ix: 5
                }
              },
              {
                ty: 0,
                nm: "Vertical Feather",
                mn: "ADBE Fill-0004",
                ix: 6,
                v: {
                  a: 0,
                  k: 0,
                  ix: 6
                }
              },
              {
                ty: 0,
                nm: "Opacity",
                mn: "ADBE Fill-0005",
                ix: 7,
                v: {
                  a: 0,
                  k: 1,
                  ix: 7
                }
              }
            ]
          }
        ],
        sw: 1080,
        sh: 1080,
        sc: "#ffffff",
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_1",
    layers: [
      {
        ddd: 1,
        ind: 5,
        ty: 4,
        nm: "Right Arm",
        parent: 6,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: -6,
            ix: 8
          },
          ry: {
            a: 0,
            k: -35,
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -12
                ],
                e: [
                  -39
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  -39
                ],
                e: [
                  29
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  29
                ],
                e: [
                  -12
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              90,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              -426.917,
              38.5,
              -65.667
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -8,
              -18,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              173.333,
              173.333,
              173.333
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596124387255,
                    0.505123721852,
                    0.401571236405,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 14,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.22981004902,
                    0.22981004902,
                    0.22981004902,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 6,
        ty: 3,
        nm: "Central",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 0,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -46
                ],
                e: [
                  -75
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  -75
                ],
                e: [
                  -54
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -54
                ],
                e: [
                  -46
                ]
              },
              {
                t: 22
              }
            ],
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  0
                ],
                e: [
                  3
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  3
                ],
                e: [
                  -9
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -9
                ],
                e: [
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 0,
                s: [
                  0,
                  -15,
                  0
                ],
                e: [
                  0,
                  -30,
                  0
                ],
                to: [
                  0,
                  -2.5,
                  0
                ],
                ti: [
                  0,
                  -2.5,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 5,
                s: [
                  0,
                  -30,
                  0
                ],
                e: [
                  0,
                  0,
                  0
                ],
                to: [
                  0,
                  2.5,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 9,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -30,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 14,
                s: [
                  0,
                  -30,
                  0
                ],
                e: [
                  0,
                  0,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  -2.5,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 18,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -15,
                  0
                ],
                to: [
                  0,
                  2.5,
                  0
                ],
                ti: [
                  0,
                  2.5,
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              48,
              48,
              48
            ],
            ix: 6
          }
        },
        ao: 0,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 7,
        ty: 0,
        nm: "Face",
        parent: 6,
        refId: "comp_2",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              0,
              -314
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        tm: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.833
                ],
                y: [
                  0.833
                ]
              },
              o: {
                x: [
                  0.167
                ],
                y: [
                  0.167
                ]
              },
              n: [
                "0p833_0p833_0p167_0p167"
              ],
              t: 0,
              s: [
                0
              ],
              e: [
                20
              ]
            },
            {
              t: 6140
            }
          ],
          ix: 2
        },
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 8,
        ty: 0,
        nm: "Top",
        parent: 6,
        refId: "comp_3",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 90,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              -320,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 9,
        ty: 0,
        nm: "Left Side",
        parent: 6,
        refId: "comp_4",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 90,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              318,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 10,
        ty: 0,
        nm: "Right Side",
        parent: 6,
        refId: "comp_5",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 90,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              -318,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 11,
        ty: 0,
        nm: "Back",
        parent: 6,
        refId: "comp_6",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              0,
              318
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 12,
        ty: 4,
        nm: "Left Arm",
        parent: 6,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 155,
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  0
                ],
                e: [
                  25
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  25
                ],
                e: [
                  -25
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -25
                ],
                e: [
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              270,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              322.917,
              38.5,
              -8.333
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -8,
              -18,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              173.333,
              173.333,
              173.333
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -80,
                        -101
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        98.134,
                        123.894
                      ]
                    ],
                    v: [
                      [
                        -8,
                        -18
                      ],
                      [
                        7,
                        213
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596124387255,
                    0.505123721852,
                    0.401571236405,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 14,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.22981004902,
                    0.22981004902,
                    0.22981004902,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 13,
        ty: 4,
        nm: "Shape Layer 1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 28,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              -9,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              -83,
                              247
                            ],
                            [
                              -143,
                              280.5
                            ],
                            [
                              44,
                              285
                            ],
                            [
                              98,
                              251
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              -83,
                              247
                            ],
                            [
                              -143,
                              280.5
                            ],
                            [
                              44,
                              285
                            ],
                            [
                              98,
                              251
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      t: 22
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.400000029919,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 14,
        ty: 4,
        nm: "L_Leg",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: -25,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              36,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              984.169,
              572,
              41.772
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              246,
              246,
              246
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -7.667,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -6.625,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -5.584,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -4.542,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -3.5,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -2.459,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -1.417,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              12.358,
                              -25.295
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              0.041,
                              97.652
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 1,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              12.358,
                              -25.295
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              0.041,
                              97.652
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 2.75,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 3.791,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 4.833,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 5.875,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 6.916,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 7.958,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 10.041,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 11.083,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 12.125,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 13.166,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 14.208,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 15.25,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 16.291,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17.333,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 18.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 19.416,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 20.458,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              12.358,
                              -25.295
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              0.041,
                              97.652
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22.0003255208333
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 6,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: -57.6666666666667,
        op: 150.666666666667,
        st: -57.6666666666667,
        bm: 0
      },
      {
        ddd: 1,
        ind: 15,
        ty: 4,
        nm: "R_Leg",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: -25,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              36,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              927.741,
              572,
              -35.894
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              246,
              246,
              246
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 1,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              4.449,
                              97.61
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 2.75,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 3.792,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 4.833,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 5.875,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 6.917,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 7.958,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 10.042,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 11.083,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 12.125,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 13.167,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 14.208,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 15.25,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 16.292,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17.333,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 18.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 19.417,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 20.458,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              4.449,
                              97.61
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 6,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: -41,
        op: 167.333333333333,
        st: -41,
        bm: 0
      }
    ]
  },
  {
    id: "comp_2",
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Shape Layer 39",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              310,
              316,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -116,
                        116
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        116,
                        -116
                      ]
                    ],
                    v: [
                      [
                        -114,
                        156
                      ],
                      [
                        118,
                        152
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.400000029919,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 21,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.310983455882,
                    0.310983455882,
                    0.310983455882,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 3,
        nm: "Eyes",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 0,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              316,
              343,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Shape Layer 38",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 740,
        op: 740.252525252525,
        st: -13,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Shape Layer 32",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 617,
        op: 617.252525252525,
        st: -136,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Shape Layer 26",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 492,
        op: 498,
        st: -261,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "Shape Layer 20",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 366,
        op: 372,
        st: -387,
        bm: 0
      },
      {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "Shape Layer 8",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 109,
        op: 115,
        st: -644,
        bm: 0
      },
      {
        ddd: 0,
        ind: 8,
        ty: 4,
        nm: "Shape Layer 37",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 721,
        op: 721.252525252525,
        st: -32,
        bm: 0
      },
      {
        ddd: 0,
        ind: 9,
        ty: 4,
        nm: "Shape Layer 31",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 598,
        op: 598.252525252525,
        st: -155,
        bm: 0
      },
      {
        ddd: 0,
        ind: 10,
        ty: 4,
        nm: "Shape Layer 25",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 473,
        op: 477,
        st: -280,
        bm: 0
      },
      {
        ddd: 0,
        ind: 11,
        ty: 4,
        nm: "Shape Layer 19",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 347,
        op: 351,
        st: -406,
        bm: 0
      },
      {
        ddd: 0,
        ind: 12,
        ty: 4,
        nm: "Shape Layer 7",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 100,
        op: 104,
        st: -653,
        bm: 0
      },
      {
        ddd: 0,
        ind: 13,
        ty: 4,
        nm: "Shape Layer 36",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 659,
        op: 659.252525252525,
        st: -94,
        bm: 0
      },
      {
        ddd: 0,
        ind: 14,
        ty: 4,
        nm: "Shape Layer 30",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 536,
        op: 536.252525252525,
        st: -217,
        bm: 0
      },
      {
        ddd: 0,
        ind: 15,
        ty: 4,
        nm: "Shape Layer 24",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 411,
        op: 417,
        st: -342,
        bm: 0
      },
      {
        ddd: 0,
        ind: 16,
        ty: 4,
        nm: "Shape Layer 18",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 285,
        op: 291,
        st: -468,
        bm: 0
      },
      {
        ddd: 0,
        ind: 17,
        ty: 4,
        nm: "Shape Layer 12",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 163,
        op: 169,
        st: -590,
        bm: 0
      },
      {
        ddd: 0,
        ind: 18,
        ty: 4,
        nm: "Shape Layer 6",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 38,
        op: 44,
        st: -715,
        bm: 0
      },
      {
        ddd: 0,
        ind: 19,
        ty: 4,
        nm: "Shape Layer 5",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              36,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.4,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 20,
        ty: 4,
        nm: "Shape Layer 35",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 740,
        op: 740.252525252525,
        st: -13,
        bm: 0
      },
      {
        ddd: 0,
        ind: 21,
        ty: 4,
        nm: "Shape Layer 29",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 617,
        op: 617.252525252525,
        st: -136,
        bm: 0
      },
      {
        ddd: 0,
        ind: 22,
        ty: 4,
        nm: "Shape Layer 23",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 492,
        op: 498,
        st: -261,
        bm: 0
      },
      {
        ddd: 0,
        ind: 23,
        ty: 4,
        nm: "Shape Layer 17",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 366,
        op: 372,
        st: -387,
        bm: 0
      },
      {
        ddd: 0,
        ind: 24,
        ty: 4,
        nm: "Shape Layer 4",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 109,
        op: 115,
        st: -644,
        bm: 0
      },
      {
        ddd: 0,
        ind: 25,
        ty: 4,
        nm: "Shape Layer 34",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 721,
        op: 721.252525252525,
        st: -32,
        bm: 0
      },
      {
        ddd: 0,
        ind: 26,
        ty: 4,
        nm: "Shape Layer 28",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 598,
        op: 598.252525252525,
        st: -155,
        bm: 0
      },
      {
        ddd: 0,
        ind: 27,
        ty: 4,
        nm: "Shape Layer 22",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 473,
        op: 477,
        st: -280,
        bm: 0
      },
      {
        ddd: 0,
        ind: 28,
        ty: 4,
        nm: "Shape Layer 16",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 347,
        op: 351,
        st: -406,
        bm: 0
      },
      {
        ddd: 0,
        ind: 29,
        ty: 4,
        nm: "Shape Layer 3",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 100,
        op: 104,
        st: -653,
        bm: 0
      },
      {
        ddd: 0,
        ind: 30,
        ty: 4,
        nm: "Shape Layer 33",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 659,
        op: 659.252525252525,
        st: -94,
        bm: 0
      },
      {
        ddd: 0,
        ind: 31,
        ty: 4,
        nm: "Shape Layer 27",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 536,
        op: 536.252525252525,
        st: -217,
        bm: 0
      },
      {
        ddd: 0,
        ind: 32,
        ty: 4,
        nm: "Shape Layer 21",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 411,
        op: 417,
        st: -342,
        bm: 0
      },
      {
        ddd: 0,
        ind: 33,
        ty: 4,
        nm: "Shape Layer 15",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 285,
        op: 291,
        st: -468,
        bm: 0
      },
      {
        ddd: 0,
        ind: 34,
        ty: 4,
        nm: "Shape Layer 9",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 163,
        op: 169,
        st: -590,
        bm: 0
      },
      {
        ddd: 0,
        ind: 35,
        ty: 4,
        nm: "Shape Layer 2",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 38,
        op: 44,
        st: -715,
        bm: 0
      },
      {
        ddd: 0,
        ind: 36,
        ty: 4,
        nm: "Shape Layer 1",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              36,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.4,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 37,
        ty: 4,
        nm: "Face",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              315.5,
              316,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -160,
              -102,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              274.927,
              274.927,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    230.953,
                    230.953
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    1,
                    1,
                    1,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -160,
                    -102
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_3",
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Face",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              315.5,
              316,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -160,
              -102,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              274.927,
              274.927,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    230.953,
                    230.953
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    1,
                    1,
                    1,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -160,
                    -102
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_4",
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Face",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              315.5,
              316,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -160,
              -102,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              274.927,
              274.927,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    230.953,
                    230.953
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    1,
                    1,
                    1,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.776470648074,
                    0.654901960784,
                    0.513725490196,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -160,
                    -102
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_5",
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Shape Layer 1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              124,
              496,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              44,
              44,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        -129,
                        143
                      ],
                      [
                        -129,
                        175
                      ],
                      [
                        130,
                        177
                      ],
                      [
                        129,
                        145
                      ]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.400000029919,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.310983455882,
                    0.310983455882,
                    0.310983455882,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 3",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        -57,
                        -188
                      ],
                      [
                        -98,
                        -117
                      ],
                      [
                        -74,
                        -117
                      ],
                      [
                        -74,
                        125
                      ],
                      [
                        -40,
                        126
                      ],
                      [
                        -40,
                        -118
                      ],
                      [
                        -16,
                        -120
                      ]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.400000029919,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.310983455882,
                    0.310983455882,
                    0.310983455882,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    111,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 2",
            np: 3,
            cix: 2,
            ix: 2,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        -57,
                        -188
                      ],
                      [
                        -98,
                        -117
                      ],
                      [
                        -74,
                        -117
                      ],
                      [
                        -74,
                        125
                      ],
                      [
                        -40,
                        126
                      ],
                      [
                        -40,
                        -118
                      ],
                      [
                        -16,
                        -120
                      ]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.400000029919,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.310983455882,
                    0.310983455882,
                    0.310983455882,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 3,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Face",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              315.5,
              316,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -160,
              -102,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              274.927,
              274.927,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    230.953,
                    230.953
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    1,
                    1,
                    1,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.776470648074,
                    0.654901960784,
                    0.513725490196,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -160,
                    -102
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_6",
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Face",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              315.5,
              316,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -160,
              -102,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              274.927,
              274.927,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    230.953,
                    230.953
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    1,
                    1,
                    1,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.776470648074,
                    0.654901960784,
                    0.513725490196,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -160,
                    -102
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_7",
    layers: [
      {
        ddd: 1,
        ind: 5,
        ty: 4,
        nm: "Right Arm",
        parent: 6,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: -6,
            ix: 8
          },
          ry: {
            a: 0,
            k: -35,
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  29
                ],
                e: [
                  -39
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  -39
                ],
                e: [
                  29
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  29
                ],
                e: [
                  -12
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              90,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              -426.917,
              38.5,
              -65.667
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -8,
              -18,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              173.333,
              173.333,
              173.333
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596124387255,
                    0.505123721852,
                    0.401571236405,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 14,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.22981004902,
                    0.22981004902,
                    0.22981004902,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 6,
        ty: 3,
        nm: "Central",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 0,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -54
                ],
                e: [
                  -75
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  -75
                ],
                e: [
                  -54
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -54
                ],
                e: [
                  -46
                ]
              },
              {
                t: 22
              }
            ],
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -9
                ],
                e: [
                  3
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  3
                ],
                e: [
                  -9
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -9
                ],
                e: [
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 0,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -30,
                  0
                ],
                to: [
                  0,
                  -5,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 5,
                s: [
                  0,
                  -30,
                  0
                ],
                e: [
                  0,
                  0,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 9,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -30,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 14,
                s: [
                  0,
                  -30,
                  0
                ],
                e: [
                  0,
                  0,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  -2.5,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 18,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -15,
                  0
                ],
                to: [
                  0,
                  2.5,
                  0
                ],
                ti: [
                  0,
                  2.5,
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              48,
              48,
              48
            ],
            ix: 6
          }
        },
        ao: 0,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 7,
        ty: 0,
        nm: "Face",
        parent: 6,
        refId: "comp_2",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              0,
              -314
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        tm: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.833
                ],
                y: [
                  0.833
                ]
              },
              o: {
                x: [
                  0.167
                ],
                y: [
                  0.167
                ]
              },
              n: [
                "0p833_0p833_0p167_0p167"
              ],
              t: -26,
              s: [
                0
              ],
              e: [
                20
              ]
            },
            {
              t: 6114
            }
          ],
          ix: 2
        },
        w: 632,
        h: 632,
        ip: -26,
        op: 4476,
        st: -26,
        bm: 0
      },
      {
        ddd: 1,
        ind: 8,
        ty: 0,
        nm: "Top",
        parent: 6,
        refId: "comp_3",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 90,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              -320,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 9,
        ty: 0,
        nm: "Left Side",
        parent: 6,
        refId: "comp_4",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 90,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              318,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 10,
        ty: 0,
        nm: "Right Side",
        parent: 6,
        refId: "comp_5",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 90,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              -318,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 11,
        ty: 0,
        nm: "Back",
        parent: 6,
        refId: "comp_6",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              0,
              318
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 12,
        ty: 4,
        nm: "Left Arm",
        parent: 6,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 155,
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -25
                ],
                e: [
                  25
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  25
                ],
                e: [
                  -25
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -25
                ],
                e: [
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              270,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              322.917,
              38.5,
              -8.333
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -8,
              -18,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              173.333,
              173.333,
              173.333
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -80,
                        -101
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        98.134,
                        123.894
                      ]
                    ],
                    v: [
                      [
                        -8,
                        -18
                      ],
                      [
                        7,
                        213
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596124387255,
                    0.505123721852,
                    0.401571236405,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 14,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.22981004902,
                    0.22981004902,
                    0.22981004902,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 13,
        ty: 4,
        nm: "L_Leg",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: -25,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              36,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              984.169,
              572,
              41.772
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              246,
              246,
              246
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -7.667,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -6.625,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -5.584,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -4.542,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -3.5,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -2.459,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -1.417,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -0.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0.666,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 1.708,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 2.75,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 3.791,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 4.833,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 5.875,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 6.916,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 7.958,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 10.041,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 11.083,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 12.125,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 13.166,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 14.208,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 15.25,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 16.291,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17.333,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 18.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 19.416,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 20.458,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              12.358,
                              -25.295
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              0.041,
                              97.652
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22.0003255208333
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 6,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: -57.6666666666667,
        op: 3400.33333333333,
        st: -57.6666666666667,
        bm: 0
      },
      {
        ddd: 1,
        ind: 14,
        ty: 4,
        nm: "R_Leg",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: -25,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              36,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              927.741,
              572,
              -35.894
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              246,
              246,
              246
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0.667,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 1.708,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 2.75,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 3.792,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 4.833,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 5.875,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 6.917,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 7.958,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 10.042,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 11.083,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 12.125,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 13.167,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 14.208,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 15.25,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 16.292,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17.333,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 18.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 19.417,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 20.458,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              4.449,
                              97.61
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 6,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: -41,
        op: 3417,
        st: -41,
        bm: 0
      },
      {
        ddd: 0,
        ind: 15,
        ty: 4,
        nm: "Shape Layer 1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 28,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              -9,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              -83,
                              247
                            ],
                            [
                              -143,
                              280.5
                            ],
                            [
                              44,
                              285
                            ],
                            [
                              98,
                              251
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              -83,
                              247
                            ],
                            [
                              -143,
                              280.5
                            ],
                            [
                              44,
                              285
                            ],
                            [
                              98,
                              251
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      t: 22
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.400000029919,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_8",
    layers: [
      {
        ddd: 1,
        ind: 5,
        ty: 4,
        nm: "Right Arm",
        parent: 6,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: -6,
            ix: 8
          },
          ry: {
            a: 0,
            k: -35,
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  29
                ],
                e: [
                  -39
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  -39
                ],
                e: [
                  29
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  29
                ],
                e: [
                  -12
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              90,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              -426.917,
              38.5,
              -65.667
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -8,
              -18,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              173.333,
              173.333,
              173.333
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 22,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 132,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -4.907,
                              -21.751
                            ],
                            [
                              -60.412,
                              -2.03
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              11.758,
                              52.115
                            ],
                            [
                              157.961,
                              5.307
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -2.138,
                              85.284
                            ],
                            [
                              163.497,
                              183.195
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 139,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -4.907,
                              -21.751
                            ],
                            [
                              -60.412,
                              -2.03
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              11.758,
                              52.115
                            ],
                            [
                              157.961,
                              5.307
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -2.138,
                              85.284
                            ],
                            [
                              163.497,
                              183.195
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -4.907,
                              -21.751
                            ],
                            [
                              -60.412,
                              -2.03
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              11.758,
                              52.115
                            ],
                            [
                              157.961,
                              5.307
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -2.138,
                              85.284
                            ],
                            [
                              163.497,
                              183.195
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 162,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -4.907,
                              -21.751
                            ],
                            [
                              -60.412,
                              -2.03
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              11.758,
                              52.115
                            ],
                            [
                              157.961,
                              5.307
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -2.138,
                              85.284
                            ],
                            [
                              163.497,
                              183.195
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 169
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596124387255,
                    0.505123721852,
                    0.401571236405,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 14,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.22981004902,
                    0.22981004902,
                    0.22981004902,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 6,
        ty: 3,
        nm: "Central",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 0,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -54
                ],
                e: [
                  -75
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  -75
                ],
                e: [
                  -54
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -54
                ],
                e: [
                  -46
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 22,
                s: [
                  -46
                ],
                e: [
                  -46
                ]
              },
              {
                i: {
                  x: [
                    0.667
                  ],
                  y: [
                    1
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0
                  ]
                },
                n: [
                  "0p667_1_0p167_0"
                ],
                t: 125,
                s: [
                  -46
                ],
                e: [
                  -46
                ]
              },
              {
                i: {
                  x: [
                    0.667
                  ],
                  y: [
                    1
                  ]
                },
                o: {
                  x: [
                    0.333
                  ],
                  y: [
                    0
                  ]
                },
                n: [
                  "0p667_1_0p333_0"
                ],
                t: 131.554,
                s: [
                  -46
                ],
                e: [
                  -25
                ]
              },
              {
                i: {
                  x: [
                    0.667
                  ],
                  y: [
                    1
                  ]
                },
                o: {
                  x: [
                    0.333
                  ],
                  y: [
                    0
                  ]
                },
                n: [
                  "0p667_1_0p333_0"
                ],
                t: 138.838,
                s: [
                  -25
                ],
                e: [
                  -25
                ]
              },
              {
                i: {
                  x: [
                    0.667
                  ],
                  y: [
                    1
                  ]
                },
                o: {
                  x: [
                    0.333
                  ],
                  y: [
                    0
                  ]
                },
                n: [
                  "0p667_1_0p333_0"
                ],
                t: 162,
                s: [
                  -25
                ],
                e: [
                  -46
                ]
              },
              {
                t: 169.5537109375
              }
            ],
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -9
                ],
                e: [
                  3
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  3
                ],
                e: [
                  -9
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -9
                ],
                e: [
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 0,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -30,
                  0
                ],
                to: [
                  0,
                  -5,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 5,
                s: [
                  0,
                  -30,
                  0
                ],
                e: [
                  0,
                  0,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 9,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -30,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 14,
                s: [
                  0,
                  -30,
                  0
                ],
                e: [
                  0,
                  0,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  -2.5,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 18,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -15,
                  0
                ],
                to: [
                  0,
                  2.5,
                  0
                ],
                ti: [
                  0,
                  2.5,
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              48,
              48,
              48
            ],
            ix: 6
          }
        },
        ao: 0,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 7,
        ty: 0,
        nm: "Face Look",
        parent: 6,
        refId: "comp_9",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              0,
              -314
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 9,
        ty: 0,
        nm: "Top",
        parent: 6,
        refId: "comp_3",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 90,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              -320,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 10,
        ty: 0,
        nm: "Left Side",
        parent: 6,
        refId: "comp_4",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 90,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              318,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 11,
        ty: 0,
        nm: "Right Side",
        parent: 6,
        refId: "comp_5",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 90,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              -318,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 12,
        ty: 0,
        nm: "Back",
        parent: 6,
        refId: "comp_6",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              0,
              318
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 13,
        ty: 4,
        nm: "L_Leg",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: -25,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              36,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              984.169,
              572,
              41.772
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              246,
              246,
              246
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -7.667,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -6.625,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -5.584,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -4.542,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -3.5,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -2.459,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -1.417,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -0.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0.666,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 1.708,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 2.75,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 3.791,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 4.833,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 5.875,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 6.916,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 7.958,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 10.041,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 11.083,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 12.125,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 13.166,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 14.208,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 15.25,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 16.291,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17.333,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 18.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 19.416,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 20.458,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              12.358,
                              -25.295
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              0.041,
                              97.652
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22.0003255208333
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 6,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: -57.6666666666667,
        op: 4801.33333333333,
        st: -57.6666666666667,
        bm: 0
      },
      {
        ddd: 1,
        ind: 14,
        ty: 4,
        nm: "R_Leg",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: -25,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              36,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              927.741,
              572,
              -35.894
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              246,
              246,
              246
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0.667,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 1.708,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 2.75,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 3.792,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 4.833,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 5.875,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 6.917,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 7.958,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 10.042,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 11.083,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 12.125,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 13.167,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 14.208,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 15.25,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 16.292,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17.333,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 18.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 19.417,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 20.458,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              4.449,
                              97.61
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 6,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: -41,
        op: 4818,
        st: -41,
        bm: 0
      },
      {
        ddd: 0,
        ind: 15,
        ty: 4,
        nm: "Shape Layer 1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 28,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              -9,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              -83,
                              247
                            ],
                            [
                              -143,
                              280.5
                            ],
                            [
                              44,
                              285
                            ],
                            [
                              98,
                              251
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              -83,
                              247
                            ],
                            [
                              -143,
                              280.5
                            ],
                            [
                              44,
                              285
                            ],
                            [
                              98,
                              251
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 22,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 131,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              31,
                              237
                            ],
                            [
                              -117,
                              256
                            ],
                            [
                              3,
                              288.5
                            ],
                            [
                              155.621,
                              272.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 139,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              31,
                              237
                            ],
                            [
                              -117,
                              256
                            ],
                            [
                              3,
                              288.5
                            ],
                            [
                              155.621,
                              272.104
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              31,
                              237
                            ],
                            [
                              -117,
                              256
                            ],
                            [
                              3,
                              288.5
                            ],
                            [
                              155.621,
                              272.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 162,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              31,
                              237
                            ],
                            [
                              -117,
                              256
                            ],
                            [
                              3,
                              288.5
                            ],
                            [
                              155.621,
                              272.104
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      t: 170
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.400000029919,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 16,
        ty: 4,
        nm: "Left Arm",
        parent: 6,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 155,
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -25
                ],
                e: [
                  25
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  25
                ],
                e: [
                  -25
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -25
                ],
                e: [
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              270,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              322.917,
              38.5,
              -8.333
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -8,
              -18,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              173.333,
              173.333,
              173.333
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -80,
                        -101
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        98.134,
                        123.894
                      ]
                    ],
                    v: [
                      [
                        -8,
                        -18
                      ],
                      [
                        7,
                        213
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596124387255,
                    0.505123721852,
                    0.401571236405,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 14,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.22981004902,
                    0.22981004902,
                    0.22981004902,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_9",
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Shape Layer 39",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              -6,
              -27,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -116,
                        116
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        116,
                        -116
                      ]
                    ],
                    v: [
                      [
                        -114,
                        156
                      ],
                      [
                        118,
                        152
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.400000029919,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 21,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.310983455882,
                    0.310983455882,
                    0.310983455882,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 3,
        nm: "Eyes",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 0,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 134,
                s: [
                  316,
                  343,
                  0
                ],
                e: [
                  239,
                  383,
                  0
                ],
                to: [
                  -12.8333330154419,
                  6.66666650772095,
                  0
                ],
                ti: [
                  12.8333330154419,
                  -6.66666650772095,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 141,
                s: [
                  239,
                  383,
                  0
                ],
                e: [
                  239,
                  383,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 162,
                s: [
                  239,
                  383,
                  0
                ],
                e: [
                  316,
                  343,
                  0
                ],
                to: [
                  12.8333330154419,
                  -6.66666650772095,
                  0
                ],
                ti: [
                  -12.8333330154419,
                  6.66666650772095,
                  0
                ]
              },
              {
                t: 169
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Shape Layer 38",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 740,
        op: 740.252525252525,
        st: -13,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Shape Layer 32",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 617,
        op: 617.252525252525,
        st: -136,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Shape Layer 26",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 492,
        op: 498,
        st: -261,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "Shape Layer 20",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 366,
        op: 372,
        st: -387,
        bm: 0
      },
      {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "Shape Layer 8",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 109,
        op: 115,
        st: -644,
        bm: 0
      },
      {
        ddd: 0,
        ind: 8,
        ty: 4,
        nm: "Shape Layer 37",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 721,
        op: 721.252525252525,
        st: -32,
        bm: 0
      },
      {
        ddd: 0,
        ind: 9,
        ty: 4,
        nm: "Shape Layer 31",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 598,
        op: 598.252525252525,
        st: -155,
        bm: 0
      },
      {
        ddd: 0,
        ind: 10,
        ty: 4,
        nm: "Shape Layer 25",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 473,
        op: 477,
        st: -280,
        bm: 0
      },
      {
        ddd: 0,
        ind: 11,
        ty: 4,
        nm: "Shape Layer 19",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 347,
        op: 351,
        st: -406,
        bm: 0
      },
      {
        ddd: 0,
        ind: 12,
        ty: 4,
        nm: "Shape Layer 7",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 100,
        op: 104,
        st: -653,
        bm: 0
      },
      {
        ddd: 0,
        ind: 13,
        ty: 4,
        nm: "Shape Layer 36",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 659,
        op: 659.252525252525,
        st: -94,
        bm: 0
      },
      {
        ddd: 0,
        ind: 14,
        ty: 4,
        nm: "Shape Layer 30",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 536,
        op: 536.252525252525,
        st: -217,
        bm: 0
      },
      {
        ddd: 0,
        ind: 15,
        ty: 4,
        nm: "Shape Layer 24",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 411,
        op: 417,
        st: -342,
        bm: 0
      },
      {
        ddd: 0,
        ind: 16,
        ty: 4,
        nm: "Shape Layer 18",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 285,
        op: 291,
        st: -468,
        bm: 0
      },
      {
        ddd: 0,
        ind: 17,
        ty: 4,
        nm: "Shape Layer 12",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 163,
        op: 169,
        st: -590,
        bm: 0
      },
      {
        ddd: 0,
        ind: 18,
        ty: 4,
        nm: "Shape Layer 6",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 38,
        op: 44,
        st: -715,
        bm: 0
      },
      {
        ddd: 0,
        ind: 19,
        ty: 4,
        nm: "Shape Layer 5",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              244,
              36,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.4,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 20,
        ty: 4,
        nm: "Shape Layer 35",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 740,
        op: 740.252525252525,
        st: -13,
        bm: 0
      },
      {
        ddd: 0,
        ind: 21,
        ty: 4,
        nm: "Shape Layer 29",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 617,
        op: 617.252525252525,
        st: -136,
        bm: 0
      },
      {
        ddd: 0,
        ind: 22,
        ty: 4,
        nm: "Shape Layer 23",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 492,
        op: 498,
        st: -261,
        bm: 0
      },
      {
        ddd: 0,
        ind: 23,
        ty: 4,
        nm: "Shape Layer 17",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 366,
        op: 372,
        st: -387,
        bm: 0
      },
      {
        ddd: 0,
        ind: 24,
        ty: 4,
        nm: "Shape Layer 4",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 109,
        op: 115,
        st: -644,
        bm: 0
      },
      {
        ddd: 0,
        ind: 25,
        ty: 4,
        nm: "Shape Layer 34",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 721,
        op: 721.252525252525,
        st: -32,
        bm: 0
      },
      {
        ddd: 0,
        ind: 26,
        ty: 4,
        nm: "Shape Layer 28",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 598,
        op: 598.252525252525,
        st: -155,
        bm: 0
      },
      {
        ddd: 0,
        ind: 27,
        ty: 4,
        nm: "Shape Layer 22",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 473,
        op: 477,
        st: -280,
        bm: 0
      },
      {
        ddd: 0,
        ind: 28,
        ty: 4,
        nm: "Shape Layer 16",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 347,
        op: 351,
        st: -406,
        bm: 0
      },
      {
        ddd: 0,
        ind: 29,
        ty: 4,
        nm: "Shape Layer 3",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 100,
        op: 104,
        st: -653,
        bm: 0
      },
      {
        ddd: 0,
        ind: 30,
        ty: 4,
        nm: "Shape Layer 33",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 659,
        op: 659.252525252525,
        st: -94,
        bm: 0
      },
      {
        ddd: 0,
        ind: 31,
        ty: 4,
        nm: "Shape Layer 27",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 536,
        op: 536.252525252525,
        st: -217,
        bm: 0
      },
      {
        ddd: 0,
        ind: 32,
        ty: 4,
        nm: "Shape Layer 21",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 411,
        op: 417,
        st: -342,
        bm: 0
      },
      {
        ddd: 0,
        ind: 33,
        ty: 4,
        nm: "Shape Layer 15",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 285,
        op: 291,
        st: -468,
        bm: 0
      },
      {
        ddd: 0,
        ind: 34,
        ty: 4,
        nm: "Shape Layer 9",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 163,
        op: 169,
        st: -590,
        bm: 0
      },
      {
        ddd: 0,
        ind: 35,
        ty: 4,
        nm: "Shape Layer 2",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              31,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.85882358925,
                    0.725490196078,
                    0.580392156863,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 38,
        op: 44,
        st: -715,
        bm: 0
      },
      {
        ddd: 0,
        ind: 36,
        ty: 4,
        nm: "Shape Layer 1",
        parent: 2,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              0,
              36,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    56.203,
                    56.203
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.38431372549,
                    0.38431372549,
                    0.38431372549,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.4,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -126.375,
                    -37.277
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 37,
        ty: 4,
        nm: "Face",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              315.5,
              316,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -160,
              -102,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              274.927,
              274.927,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    230.953,
                    230.953
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    1,
                    1,
                    1,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.862745157878,
                    0.725490196078,
                    0.572549019608,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -160,
                    -102
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_10",
    layers: [
      {
        ddd: 0,
        ind: 1,
        ty: 4,
        nm: "Shape Layer 1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              400,
              283,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        6,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        2,
                        -1
                      ],
                      [
                        -0.5,
                        -4
                      ],
                      [
                        3,
                        0.5
                      ],
                      [
                        -4,
                        -9.5
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -0.5,
                        8
                      ],
                      [
                        2,
                        3.5
                      ],
                      [
                        0.5,
                        10
                      ]
                    ],
                    o: [
                      [
                        -6,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        -2,
                        1
                      ],
                      [
                        0.5,
                        4
                      ],
                      [
                        -3,
                        -0.5
                      ],
                      [
                        4,
                        9.5
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0.5,
                        -8
                      ],
                      [
                        -2,
                        -3.5
                      ],
                      [
                        -0.5,
                        -10
                      ]
                    ],
                    v: [
                      [
                        80.5,
                        80
                      ],
                      [
                        0.5,
                        80.5
                      ],
                      [
                        -85,
                        80.5
                      ],
                      [
                        -94,
                        93
                      ],
                      [
                        -81.5,
                        106
                      ],
                      [
                        -75,
                        174.5
                      ],
                      [
                        -53,
                        221.5
                      ],
                      [
                        1.5,
                        221.5
                      ],
                      [
                        53,
                        221.5
                      ],
                      [
                        77.5,
                        168.5
                      ],
                      [
                        82.5,
                        106
                      ],
                      [
                        94.5,
                        92.5
                      ]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.4,
                    0.4,
                    0.4,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.803921628466,
                    0.623529411765,
                    0.419607873056,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 2,
        ty: 4,
        nm: "Shape Layer 8",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 48,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              267.5,
              -51,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              149,
              149,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -16.18,
                        -15.794
                      ],
                      [
                        -3.859,
                        6.753
                      ],
                      [
                        27,
                        24
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        21,
                        20.5
                      ],
                      [
                        2,
                        -3.5
                      ],
                      [
                        -27,
                        -24
                      ]
                    ],
                    v: [
                      [
                        106.5,
                        -23.5
                      ],
                      [
                        126.5,
                        27.5
                      ],
                      [
                        192,
                        47
                      ],
                      [
                        171,
                        2
                      ]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 2",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 4,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 4,
        nm: "Shape Layer 10",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: -1,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              669.5,
              178,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              -127,
              127,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -16.18,
                        -15.794
                      ],
                      [
                        -3.859,
                        6.753
                      ],
                      [
                        27,
                        24
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        21,
                        20.5
                      ],
                      [
                        2,
                        -3.5
                      ],
                      [
                        -27,
                        -24
                      ]
                    ],
                    v: [
                      [
                        106.5,
                        -23.5
                      ],
                      [
                        126.5,
                        27.5
                      ],
                      [
                        192,
                        47
                      ],
                      [
                        171,
                        2
                      ]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 2",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 4,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 4,
        nm: "Shape Layer 7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 8,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              144.5,
              154,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              127,
              127,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -16.18,
                        -15.794
                      ],
                      [
                        -3.859,
                        6.753
                      ],
                      [
                        27,
                        24
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        21,
                        20.5
                      ],
                      [
                        2,
                        -3.5
                      ],
                      [
                        -27,
                        -24
                      ]
                    ],
                    v: [
                      [
                        106.5,
                        -23.5
                      ],
                      [
                        126.5,
                        27.5
                      ],
                      [
                        192,
                        47
                      ],
                      [
                        171,
                        2
                      ]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 2",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 4,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 4,
        nm: "Shape Layer 9",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              581,
              268,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              -81,
              102.87,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -16.18,
                        -15.794
                      ],
                      [
                        -3.859,
                        6.753
                      ],
                      [
                        27,
                        24
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        21,
                        20.5
                      ],
                      [
                        2,
                        -3.5
                      ],
                      [
                        -27,
                        -24
                      ]
                    ],
                    v: [
                      [
                        106.5,
                        -23.5
                      ],
                      [
                        126.5,
                        27.5
                      ],
                      [
                        192,
                        47
                      ],
                      [
                        171,
                        2
                      ]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 2",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 4,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 4,
        nm: "Shape Layer 6",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              192,
              272,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -16.18,
                        -15.794
                      ],
                      [
                        -3.859,
                        6.753
                      ],
                      [
                        27,
                        24
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        21,
                        20.5
                      ],
                      [
                        2,
                        -3.5
                      ],
                      [
                        -27,
                        -24
                      ]
                    ],
                    v: [
                      [
                        106.5,
                        -23.5
                      ],
                      [
                        126.5,
                        27.5
                      ],
                      [
                        192,
                        47
                      ],
                      [
                        171,
                        2
                      ]
                    ],
                    c: true
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 2",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 4,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 7,
        ty: 4,
        nm: "Shape Layer 5",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              192,
              272,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 8,
        ty: 4,
        nm: "Shape Layer 4",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              192,
              272,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        182,
                        40
                      ],
                      [
                        209,
                        60
                      ],
                      [
                        248,
                        34
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 10,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.803921628466,
                    0.623529411765,
                    0.419607873056,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 9,
        ty: 4,
        nm: "Shape Layer 3",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              192,
              272,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        181,
                        -36
                      ],
                      [
                        210,
                        -10
                      ],
                      [
                        243,
                        -35
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 10,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.803921628466,
                    0.623529411765,
                    0.419607873056,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 10,
        ty: 4,
        nm: "Shape Layer 2",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              192,
              272,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        0,
                        0
                      ]
                    ],
                    v: [
                      [
                        209,
                        93
                      ],
                      [
                        209,
                        -79
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.407843167174,
                    0.529411764706,
                    0.227450995352,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 10,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.803921628466,
                    0.623529411765,
                    0.419607873056,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_11",
    layers: [
      {
        ddd: 0,
        ind: 2,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 50,
                s: [
                  -98,
                  662,
                  0
                ],
                e: [
                  542,
                  666,
                  0
                ],
                to: [
                  106.666664123535,
                  0.66666668653488,
                  0
                ],
                ti: [
                  -106.666664123535,
                  -0.66666668653488,
                  0
                ]
              },
              {
                t: 72
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 50,
        op: 4552,
        st: 50,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 0,
                s: [
                  542,
                  666,
                  0
                ],
                e: [
                  1196,
                  666,
                  0
                ],
                to: [
                  109,
                  0,
                  0
                ],
                ti: [
                  -109,
                  0,
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 0,
        op: 25,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 0,
                s: [
                  1196,
                  666,
                  0
                ],
                e: [
                  1675,
                  666,
                  0
                ],
                to: [
                  79.8333358764648,
                  0,
                  0
                ],
                ti: [
                  -79.8333358764648,
                  0,
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 50,
                s: [
                  1196,
                  666,
                  0
                ],
                e: [
                  1675,
                  666,
                  0
                ],
                to: [
                  79.8333358764648,
                  0,
                  0
                ],
                ti: [
                  -79.8333358764648,
                  0,
                  0
                ]
              },
              {
                t: 72
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 50,
        op: 4552,
        st: 50,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 50,
                s: [
                  542,
                  666,
                  0
                ],
                e: [
                  1196,
                  666,
                  0
                ],
                to: [
                  109,
                  0,
                  0
                ],
                ti: [
                  -109,
                  0,
                  0
                ]
              },
              {
                t: 72
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 50,
        op: 4552,
        st: 50,
        bm: 0
      },
      {
        ddd: 0,
        ind: 7,
        ty: 0,
        nm: "STANDING M 2",
        refId: "comp_7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              1196,
              666,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 25,
        op: 50,
        st: -100,
        bm: 0
      },
      {
        ddd: 0,
        ind: 8,
        ty: 0,
        nm: "STANDING M",
        refId: "comp_7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              542,
              666,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 25,
        op: 50,
        st: -100,
        bm: 0
      },
      {
        ddd: 0,
        ind: 9,
        ty: 0,
        nm: "STANDING L ",
        refId: "comp_7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              -98,
              662,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 25,
        op: 50,
        st: -100,
        bm: 0
      },
      {
        ddd: 0,
        ind: 10,
        ty: 0,
        nm: "WALK OFF L",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 3,
                s: [
                  -498,
                  666,
                  0
                ],
                e: [
                  -98,
                  662,
                  0
                ],
                to: [
                  66.6666641235352,
                  -0.66666668653488,
                  0
                ],
                ti: [
                  -66.6666641235352,
                  0.66666668653488,
                  0
                ]
              },
              {
                t: 25
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 3,
        op: 25,
        st: 3,
        bm: 0
      },
      {
        ddd: 0,
        ind: 11,
        ty: 0,
        nm: "WALK OFF M",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 2,
                s: [
                  -98,
                  662,
                  0
                ],
                e: [
                  542,
                  666,
                  0
                ],
                to: [
                  106.666664123535,
                  0.66666668653488,
                  0
                ],
                ti: [
                  -106.666664123535,
                  -0.66666668653488,
                  0
                ]
              },
              {
                t: 24
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 2,
        op: 25,
        st: 2,
        bm: 0
      },
      {
        ddd: 0,
        ind: 12,
        ty: 0,
        nm: "STANDING",
        refId: "comp_7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              -98,
              662,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 0,
        op: 2,
        st: -125,
        bm: 0
      },
      {
        ddd: 0,
        ind: 13,
        ty: 4,
        nm: "Shape Layer 1",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              39,
              -96,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              127,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    55.855,
                    55.855
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.572,
                    143.711
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    54.004,
                    9.184
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -290.998,
                    334.513
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 2",
            np: 3,
            cix: 2,
            ix: 2,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    29.914,
                    184.656
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.645,
                    239.812
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 3,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 14,
        ty: 4,
        nm: "Shape Layer 4",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              -518,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -271,
                        153
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        271,
                        -153
                      ]
                    ],
                    v: [
                      [
                        -231,
                        90
                      ],
                      [
                        246,
                        91
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.862745098039,
                    0,
                    0.196078431373,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 18,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 15,
        ty: 4,
        nm: "Shape Layer 2",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              557,
              -96,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              127,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    55.855,
                    55.855
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.572,
                    143.711
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    54.004,
                    9.184
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -290.998,
                    334.513
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 2",
            np: 3,
            cix: 2,
            ix: 2,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    29.914,
                    184.656
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.645,
                    239.812
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 3,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 16,
        ty: 4,
        nm: "Shape Layer 5",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              518,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -271,
                        153
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        271,
                        -153
                      ]
                    ],
                    v: [
                      [
                        -231,
                        90
                      ],
                      [
                        246,
                        91
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.862745098039,
                    0,
                    0.196078431373,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 18,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 17,
        ty: 4,
        nm: "Shape Layer 3",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              540,
              454,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              126,
              126,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -271,
                        153
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        271,
                        -153
                      ]
                    ],
                    v: [
                      [
                        -231,
                        90
                      ],
                      [
                        246,
                        91
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.862745098039,
                    0,
                    0.196078431373,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 18,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 18,
        ty: 0,
        nm: "potted-plant-flat-vector-800x566.jpg Comp 1",
        cl: "jpg",
        refId: "comp_10",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              836,
              634,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              400,
              283,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              77,
              77,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 800,
        h: 566,
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 19,
        ty: 0,
        nm: "potted-plant-flat-vector-800x566.jpg Comp 1",
        cl: "jpg",
        refId: "comp_10",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              256,
              634,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              400,
              283,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              77,
              77,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 800,
        h: 566,
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 20,
        ty: 1,
        nm: "White Solid 2",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              540,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              540,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        ef: [
          {
            ty: 21,
            nm: "Fill",
            np: 9,
            mn: "ADBE Fill",
            ix: 2,
            en: 1,
            ef: [
              {
                ty: 10,
                nm: "Fill Mask",
                mn: "ADBE Fill-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 0,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "All Masks",
                mn: "ADBE Fill-0007",
                ix: 2,
                v: {
                  a: 0,
                  k: 0,
                  ix: 2
                }
              },
              {
                ty: 2,
                nm: "Color",
                mn: "ADBE Fill-0002",
                ix: 3,
                v: {
                  a: 0,
                  k: [
                    0.849969387054,
                    0.936350643635,
                    1,
                    1
                  ],
                  ix: 3
                }
              },
              {
                ty: 7,
                nm: "Invert",
                mn: "ADBE Fill-0006",
                ix: 4,
                v: {
                  a: 0,
                  k: 0,
                  ix: 4
                }
              },
              {
                ty: 0,
                nm: "Horizontal Feather",
                mn: "ADBE Fill-0003",
                ix: 5,
                v: {
                  a: 0,
                  k: 0,
                  ix: 5
                }
              },
              {
                ty: 0,
                nm: "Vertical Feather",
                mn: "ADBE Fill-0004",
                ix: 6,
                v: {
                  a: 0,
                  k: 0,
                  ix: 6
                }
              },
              {
                ty: 0,
                nm: "Opacity",
                mn: "ADBE Fill-0005",
                ix: 7,
                v: {
                  a: 0,
                  k: 1,
                  ix: 7
                }
              }
            ]
          }
        ],
        sw: 1080,
        sh: 1080,
        sc: "#ffffff",
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_12",
    layers: [
      {
        ddd: 0,
        ind: 2,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 75,
                s: [
                  -98,
                  662,
                  0
                ],
                e: [
                  542,
                  666,
                  0
                ],
                to: [
                  106.666664123535,
                  0.66666668653488,
                  0
                ],
                ti: [
                  -106.666664123535,
                  -0.66666668653488,
                  0
                ]
              },
              {
                t: 97
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 75,
        op: 4577,
        st: 75,
        bm: 0
      },
      {
        ddd: 0,
        ind: 3,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 0,
                s: [
                  542,
                  666,
                  0
                ],
                e: [
                  1196,
                  666,
                  0
                ],
                to: [
                  109,
                  0,
                  0
                ],
                ti: [
                  -109,
                  0,
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 0,
        op: 25,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 4,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 0,
                s: [
                  1196,
                  666,
                  0
                ],
                e: [
                  1675,
                  666,
                  0
                ],
                to: [
                  79.8333358764648,
                  0,
                  0
                ],
                ti: [
                  -79.8333358764648,
                  0,
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 5,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 75,
                s: [
                  1196,
                  666,
                  0
                ],
                e: [
                  1675,
                  666,
                  0
                ],
                to: [
                  79.8333358764648,
                  0,
                  0
                ],
                ti: [
                  -79.8333358764648,
                  0,
                  0
                ]
              },
              {
                t: 97
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 75,
        op: 4577,
        st: 75,
        bm: 0
      },
      {
        ddd: 0,
        ind: 6,
        ty: 0,
        nm: "WALK OFF",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 75,
                s: [
                  542,
                  666,
                  0
                ],
                e: [
                  1196,
                  666,
                  0
                ],
                to: [
                  109,
                  0,
                  0
                ],
                ti: [
                  -109,
                  0,
                  0
                ]
              },
              {
                t: 97
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 75,
        op: 4577,
        st: 75,
        bm: 0
      },
      {
        ddd: 0,
        ind: 7,
        ty: 0,
        nm: "STANDING M 2",
        refId: "comp_7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              1196,
              666,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 25,
        op: 75,
        st: -100,
        bm: 0
      },
      {
        ddd: 0,
        ind: 8,
        ty: 0,
        nm: "LOOK RIGHT",
        refId: "comp_13",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              542,
              666,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 25,
        op: 75,
        st: -101,
        bm: 0
      },
      {
        ddd: 0,
        ind: 9,
        ty: 0,
        nm: "STANDING L ",
        refId: "comp_7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              -98,
              662,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 25,
        op: 75,
        st: -100,
        bm: 0
      },
      {
        ddd: 0,
        ind: 10,
        ty: 0,
        nm: "WALK OFF L",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 3,
                s: [
                  -498,
                  666,
                  0
                ],
                e: [
                  -98,
                  662,
                  0
                ],
                to: [
                  66.6666641235352,
                  -0.66666668653488,
                  0
                ],
                ti: [
                  -66.6666641235352,
                  0.66666668653488,
                  0
                ]
              },
              {
                t: 25
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 3,
        op: 25,
        st: 3,
        bm: 0
      },
      {
        ddd: 0,
        ind: 11,
        ty: 0,
        nm: "WALK OFF M",
        refId: "comp_1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 2,
                s: [
                  -98,
                  662,
                  0
                ],
                e: [
                  542,
                  666,
                  0
                ],
                to: [
                  106.666664123535,
                  0.66666668653488,
                  0
                ],
                ti: [
                  -106.666664123535,
                  -0.66666668653488,
                  0
                ]
              },
              {
                t: 24
              }
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 2,
        op: 25,
        st: 2,
        bm: 0
      },
      {
        ddd: 0,
        ind: 12,
        ty: 0,
        nm: "STANDING",
        refId: "comp_7",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              -98,
              662,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              118,
              118,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 1920,
        h: 1080,
        ip: 0,
        op: 2,
        st: -125,
        bm: 0
      },
      {
        ddd: 0,
        ind: 13,
        ty: 4,
        nm: "Shape Layer 1",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              39,
              -96,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              127,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    55.855,
                    55.855
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.572,
                    143.711
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    54.004,
                    9.184
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -290.998,
                    334.513
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 2",
            np: 3,
            cix: 2,
            ix: 2,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    29.914,
                    184.656
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.645,
                    239.812
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 3,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 14,
        ty: 4,
        nm: "Shape Layer 4",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              -518,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -271,
                        153
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        271,
                        -153
                      ]
                    ],
                    v: [
                      [
                        -231,
                        90
                      ],
                      [
                        246,
                        91
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.862745098039,
                    0,
                    0.196078431373,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 18,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 15,
        ty: 4,
        nm: "Shape Layer 2",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              557,
              -96,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              127,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                d: 1,
                ty: "el",
                s: {
                  a: 0,
                  k: [
                    55.855,
                    55.855
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                nm: "Ellipse Path 1",
                mn: "ADBE Vector Shape - Ellipse",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.572,
                    143.711
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Ellipse 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    54.004,
                    9.184
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -290.998,
                    334.513
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 2",
            np: 3,
            cix: 2,
            ix: 2,
            mn: "ADBE Vector Group",
            hd: false
          },
          {
            ty: "gr",
            it: [
              {
                ty: "rc",
                d: 1,
                s: {
                  a: 0,
                  k: [
                    29.914,
                    184.656
                  ],
                  ix: 2
                },
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                nm: "Rectangle Path 1",
                mn: "ADBE Vector Shape - Rect",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.705882352941,
                    0.694117647059,
                    0.694117647059,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    -289.645,
                    239.812
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Rectangle 1",
            np: 3,
            cix: 2,
            ix: 3,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 16,
        ty: 4,
        nm: "Shape Layer 5",
        parent: 17,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              518,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -271,
                        153
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        271,
                        -153
                      ]
                    ],
                    v: [
                      [
                        -231,
                        90
                      ],
                      [
                        246,
                        91
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.862745098039,
                    0,
                    0.196078431373,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 18,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 17,
        ty: 4,
        nm: "Shape Layer 3",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              540,
              454,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              126,
              126,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -271,
                        153
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        271,
                        -153
                      ]
                    ],
                    v: [
                      [
                        -231,
                        90
                      ],
                      [
                        246,
                        91
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.862745098039,
                    0,
                    0.196078431373,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 18,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 18,
        ty: 0,
        nm: "potted-plant-flat-vector-800x566.jpg Comp 1",
        cl: "jpg",
        refId: "comp_10",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              836,
              634,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              400,
              283,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              77,
              77,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 800,
        h: 566,
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 19,
        ty: 0,
        nm: "potted-plant-flat-vector-800x566.jpg Comp 1",
        cl: "jpg",
        refId: "comp_10",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              256,
              634,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              400,
              283,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              77,
              77,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 800,
        h: 566,
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      },
      {
        ddd: 0,
        ind: 20,
        ty: 1,
        nm: "White Solid 2",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              540,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              540,
              540,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        ef: [
          {
            ty: 21,
            nm: "Fill",
            np: 9,
            mn: "ADBE Fill",
            ix: 2,
            en: 1,
            ef: [
              {
                ty: 10,
                nm: "Fill Mask",
                mn: "ADBE Fill-0001",
                ix: 1,
                v: {
                  a: 0,
                  k: 0,
                  ix: 1
                }
              },
              {
                ty: 7,
                nm: "All Masks",
                mn: "ADBE Fill-0007",
                ix: 2,
                v: {
                  a: 0,
                  k: 0,
                  ix: 2
                }
              },
              {
                ty: 2,
                nm: "Color",
                mn: "ADBE Fill-0002",
                ix: 3,
                v: {
                  a: 0,
                  k: [
                    0.849969387054,
                    0.936350643635,
                    1,
                    1
                  ],
                  ix: 3
                }
              },
              {
                ty: 7,
                nm: "Invert",
                mn: "ADBE Fill-0006",
                ix: 4,
                v: {
                  a: 0,
                  k: 0,
                  ix: 4
                }
              },
              {
                ty: 0,
                nm: "Horizontal Feather",
                mn: "ADBE Fill-0003",
                ix: 5,
                v: {
                  a: 0,
                  k: 0,
                  ix: 5
                }
              },
              {
                ty: 0,
                nm: "Vertical Feather",
                mn: "ADBE Fill-0004",
                ix: 6,
                v: {
                  a: 0,
                  k: 0,
                  ix: 6
                }
              },
              {
                ty: 0,
                nm: "Opacity",
                mn: "ADBE Fill-0005",
                ix: 7,
                v: {
                  a: 0,
                  k: 1,
                  ix: 7
                }
              }
            ]
          }
        ],
        sw: 1080,
        sh: 1080,
        sc: "#ffffff",
        ip: 0,
        op: 500,
        st: 0,
        bm: 0
      }
    ]
  },
  {
    id: "comp_13",
    layers: [
      {
        ddd: 1,
        ind: 5,
        ty: 3,
        nm: "Central",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 0,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -54
                ],
                e: [
                  -75
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  -75
                ],
                e: [
                  -54
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -54
                ],
                e: [
                  -46
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 22,
                s: [
                  -46
                ],
                e: [
                  -46
                ]
              },
              {
                i: {
                  x: [
                    0.667
                  ],
                  y: [
                    1
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0
                  ]
                },
                n: [
                  "0p667_1_0p167_0"
                ],
                t: 125,
                s: [
                  -46
                ],
                e: [
                  -46
                ]
              },
              {
                i: {
                  x: [
                    0.667
                  ],
                  y: [
                    1
                  ]
                },
                o: {
                  x: [
                    0.333
                  ],
                  y: [
                    0
                  ]
                },
                n: [
                  "0p667_1_0p333_0"
                ],
                t: 141.554,
                s: [
                  -46
                ],
                e: [
                  -25
                ]
              },
              {
                i: {
                  x: [
                    0.667
                  ],
                  y: [
                    1
                  ]
                },
                o: {
                  x: [
                    0.333
                  ],
                  y: [
                    0
                  ]
                },
                n: [
                  "0p667_1_0p333_0"
                ],
                t: 148.838,
                s: [
                  -25
                ],
                e: [
                  -25
                ]
              },
              {
                i: {
                  x: [
                    0.667
                  ],
                  y: [
                    1
                  ]
                },
                o: {
                  x: [
                    0.333
                  ],
                  y: [
                    0
                  ]
                },
                n: [
                  "0p667_1_0p333_0"
                ],
                t: 162,
                s: [
                  -25
                ],
                e: [
                  -46
                ]
              },
              {
                t: 169.5537109375
              }
            ],
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -9
                ],
                e: [
                  3
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  3
                ],
                e: [
                  -9
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -9
                ],
                e: [
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 1,
            k: [
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 0,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -30,
                  0
                ],
                to: [
                  0,
                  -5,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 5,
                s: [
                  0,
                  -30,
                  0
                ],
                e: [
                  0,
                  0,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 9,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -30,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  0,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 14,
                s: [
                  0,
                  -30,
                  0
                ],
                e: [
                  0,
                  0,
                  0
                ],
                to: [
                  0,
                  0,
                  0
                ],
                ti: [
                  0,
                  -2.5,
                  0
                ]
              },
              {
                i: {
                  x: 0.833,
                  y: 0.833
                },
                o: {
                  x: 0.167,
                  y: 0.167
                },
                n: "0p833_0p833_0p167_0p167",
                t: 18,
                s: [
                  0,
                  0,
                  0
                ],
                e: [
                  0,
                  -15,
                  0
                ],
                to: [
                  0,
                  2.5,
                  0
                ],
                ti: [
                  0,
                  2.5,
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              48,
              48,
              48
            ],
            ix: 6
          }
        },
        ao: 0,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 6,
        ty: 4,
        nm: "Right Arm",
        parent: 5,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: -6,
            ix: 8
          },
          ry: {
            a: 0,
            k: -35,
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  29
                ],
                e: [
                  -39
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  -39
                ],
                e: [
                  29
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  29
                ],
                e: [
                  -12
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              90,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              -426.917,
              38.5,
              -65.667
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -8,
              -18,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              173.333,
              173.333,
              173.333
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              17.705,
                              95.815
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -5.988,
                              -73.212
                            ],
                            [
                              -4.224,
                              -7.353
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              4.355,
                              53.247
                            ],
                            [
                              78.732,
                              137.045
                            ]
                          ],
                          v: [
                            [
                              -8,
                              -18
                            ],
                            [
                              -38.471,
                              97.997
                            ],
                            [
                              7,
                              213
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596124387255,
                    0.505123721852,
                    0.401571236405,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 14,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.22981004902,
                    0.22981004902,
                    0.22981004902,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 7,
        ty: 0,
        nm: "Face",
        parent: 5,
        refId: "comp_2",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              0,
              -314
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        tm: {
          a: 1,
          k: [
            {
              i: {
                x: [
                  0.833
                ],
                y: [
                  0.833
                ]
              },
              o: {
                x: [
                  0.167
                ],
                y: [
                  0.167
                ]
              },
              n: [
                "0p833_0p833_0p167_0p167"
              ],
              t: 0,
              s: [
                0
              ],
              e: [
                20
              ]
            },
            {
              t: 6140
            }
          ],
          ix: 2
        },
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 8,
        ty: 0,
        nm: "Top",
        parent: 5,
        refId: "comp_3",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 90,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              -320,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 9,
        ty: 0,
        nm: "Left Side",
        parent: 5,
        refId: "comp_4",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 90,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              318,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 10,
        ty: 0,
        nm: "Right Side",
        parent: 5,
        refId: "comp_5",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 90,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              -318,
              0,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 11,
        ty: 0,
        nm: "Back",
        parent: 5,
        refId: "comp_6",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 0,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              0,
              0,
              318
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              316,
              316,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        w: 632,
        h: 632,
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 12,
        ty: 4,
        nm: "L_Leg",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: -25,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              36,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              984.169,
              572,
              41.772
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              246,
              246,
              246
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -7.667,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -6.625,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -5.584,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -4.542,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -3.5,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -2.459,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -1.417,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: -0.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0.666,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 1.708,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 2.75,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 3.791,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 4.833,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 5.875,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 6.916,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 7.958,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 10.041,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 11.083,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 12.125,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 13.166,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 14.208,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 15.25,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 16.291,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17.333,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 18.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 19.416,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 20.458,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              12.358,
                              -25.295
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              0.041,
                              97.652
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22.0003255208333
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 6,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: -57.6666666666667,
        op: 4801.33333333333,
        st: -57.6666666666667,
        bm: 0
      },
      {
        ddd: 1,
        ind: 13,
        ty: 4,
        nm: "R_Leg",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: -25,
            ix: 9
          },
          rz: {
            a: 0,
            k: 0,
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              36,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              927.741,
              572,
              -35.894
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              0,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              246,
              246,
              246
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0.667,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 1.708,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 2.75,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 3.792,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 4.833,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              15,
                              -24.75
                            ]
                          ],
                          o: [
                            [
                              14.25,
                              25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -1,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 5.875,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19.75,
                              -22.75
                            ]
                          ],
                          o: [
                            [
                              9,
                              26
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1,
                              39.75
                            ],
                            [
                              -13.25,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 6.917,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              18,
                              -32.75
                            ]
                          ],
                          o: [
                            [
                              0.75,
                              19.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -14.25,
                              34
                            ],
                            [
                              -24.75,
                              96.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 7.958,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -7.75,
                              15.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -4.75,
                              28.75
                            ],
                            [
                              -36.25,
                              96.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              17,
                              -28.25
                            ]
                          ],
                          o: [
                            [
                              -9.75,
                              14.5
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -6,
                              25.75
                            ],
                            [
                              -48.75,
                              98
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 10.042,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              28.25,
                              -16.75
                            ]
                          ],
                          o: [
                            [
                              1,
                              17.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -7,
                              29.25
                            ],
                            [
                              -43,
                              92.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 11.083,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              45.5,
                              -13.75
                            ]
                          ],
                          o: [
                            [
                              10,
                              13.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -29.75,
                              85.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 12.125,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              46.25,
                              0
                            ]
                          ],
                          o: [
                            [
                              16,
                              2.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              -15,
                              78.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 13.167,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              40.75,
                              -27.5
                            ]
                          ],
                          o: [
                            [
                              10,
                              0.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -5.75,
                              34.5
                            ],
                            [
                              4.5,
                              74.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 14.208,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              33.75,
                              -31
                            ]
                          ],
                          o: [
                            [
                              1.75,
                              -0.25
                            ],
                            [
                              -9,
                              7
                            ]
                          ],
                          v: [
                            [
                              3.25,
                              36.5
                            ],
                            [
                              18,
                              78
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 15.25,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              19,
                              -48.5
                            ]
                          ],
                          o: [
                            [
                              20,
                              -2.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              3,
                              31.75
                            ],
                            [
                              32,
                              83.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 16.292,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -6.75,
                              -57.75
                            ]
                          ],
                          o: [
                            [
                              15.5,
                              8
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -3.25,
                              25.5
                            ],
                            [
                              42.5,
                              89.75
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17.333,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              47.75,
                              98.5
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 18.375,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              -14.25,
                              -26.25
                            ]
                          ],
                          o: [
                            [
                              9.75,
                              13.75
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              1.25,
                              25.75
                            ],
                            [
                              35.75,
                              97.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 19.417,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              3.75,
                              -33
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.25,
                              29.25
                            ],
                            [
                              23.75,
                              95.25
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 20.458,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              10.75,
                              97
                            ]
                          ],
                          c: false
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              16,
                              -33.25
                            ]
                          ],
                          o: [
                            [
                              11.75,
                              12.25
                            ],
                            [
                              -1.75,
                              13
                            ]
                          ],
                          v: [
                            [
                              -1.75,
                              34.5
                            ],
                            [
                              4.449,
                              97.61
                            ]
                          ],
                          c: false
                        }
                      ]
                    },
                    {
                      t: 22
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.45853247549,
                    0.389574776444,
                    0.308624387255,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 6,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    1,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: -41,
        op: 4818,
        st: -41,
        bm: 0
      },
      {
        ddd: 0,
        ind: 14,
        ty: 4,
        nm: "Shape Layer 1",
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 28,
            ix: 11
          },
          r: {
            a: 0,
            k: 0,
            ix: 10
          },
          p: {
            a: 0,
            k: [
              960,
              540,
              0
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              0,
              -9,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              100,
              100,
              100
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 1,
                  k: [
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 0,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              -83,
                              247
                            ],
                            [
                              -143,
                              280.5
                            ],
                            [
                              44,
                              285
                            ],
                            [
                              98,
                              251
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 9,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              -83,
                              247
                            ],
                            [
                              -143,
                              280.5
                            ],
                            [
                              44,
                              285
                            ],
                            [
                              98,
                              251
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 17,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -154.069,
                              265.612
                            ],
                            [
                              29.931,
                              290.612
                            ],
                            [
                              157.517,
                              248.983
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 22,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 141,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              31,
                              237
                            ],
                            [
                              -117,
                              256
                            ],
                            [
                              3,
                              288.5
                            ],
                            [
                              155.621,
                              272.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 149,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              31,
                              237
                            ],
                            [
                              -117,
                              256
                            ],
                            [
                              3,
                              288.5
                            ],
                            [
                              155.621,
                              272.104
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              31,
                              237
                            ],
                            [
                              -117,
                              256
                            ],
                            [
                              3,
                              288.5
                            ],
                            [
                              155.621,
                              272.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      i: {
                        x: 0.833,
                        y: 0.833
                      },
                      o: {
                        x: 0.167,
                        y: 0.167
                      },
                      n: "0p833_0p833_0p167_0p167",
                      t: 162,
                      s: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              31,
                              237
                            ],
                            [
                              -117,
                              256
                            ],
                            [
                              3,
                              288.5
                            ],
                            [
                              155.621,
                              272.104
                            ]
                          ],
                          c: true
                        }
                      ],
                      e: [
                        {
                          i: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          o: [
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ],
                            [
                              0,
                              0
                            ]
                          ],
                          v: [
                            [
                              2,
                              228
                            ],
                            [
                              -150,
                              259
                            ],
                            [
                              34,
                              284
                            ],
                            [
                              163.621,
                              256.104
                            ]
                          ],
                          c: true
                        }
                      ]
                    },
                    {
                      t: 170
                    }
                  ],
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596078431373,
                    0.505882352941,
                    0.400000029919,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0,
                    0,
                    0,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: false
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      },
      {
        ddd: 1,
        ind: 15,
        ty: 4,
        nm: "Left Arm",
        parent: 5,
        sr: 1,
        ks: {
          o: {
            a: 0,
            k: 100,
            ix: 11
          },
          rx: {
            a: 0,
            k: 0,
            ix: 8
          },
          ry: {
            a: 0,
            k: 155,
            ix: 9
          },
          rz: {
            a: 1,
            k: [
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 0,
                s: [
                  -25
                ],
                e: [
                  25
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 9,
                s: [
                  25
                ],
                e: [
                  -25
                ]
              },
              {
                i: {
                  x: [
                    0.833
                  ],
                  y: [
                    0.833
                  ]
                },
                o: {
                  x: [
                    0.167
                  ],
                  y: [
                    0.167
                  ]
                },
                n: [
                  "0p833_0p833_0p167_0p167"
                ],
                t: 17,
                s: [
                  -25
                ],
                e: [
                  0
                ]
              },
              {
                t: 22
              }
            ],
            ix: 10
          },
          or: {
            a: 0,
            k: [
              0,
              270,
              0
            ],
            ix: 7
          },
          p: {
            a: 0,
            k: [
              322.917,
              38.5,
              -8.333
            ],
            ix: 2
          },
          a: {
            a: 0,
            k: [
              -8,
              -18,
              0
            ],
            ix: 1
          },
          s: {
            a: 0,
            k: [
              173.333,
              173.333,
              173.333
            ],
            ix: 6
          }
        },
        ao: 0,
        shapes: [
          {
            ty: "gr",
            it: [
              {
                ind: 0,
                ty: "sh",
                ix: 1,
                ks: {
                  a: 0,
                  k: {
                    i: [
                      [
                        0,
                        0
                      ],
                      [
                        -80,
                        -101
                      ]
                    ],
                    o: [
                      [
                        0,
                        0
                      ],
                      [
                        98.134,
                        123.894
                      ]
                    ],
                    v: [
                      [
                        -8,
                        -18
                      ],
                      [
                        7,
                        213
                      ]
                    ],
                    c: false
                  },
                  ix: 2
                },
                nm: "Path 1",
                mn: "ADBE Vector Shape - Group",
                hd: false
              },
              {
                ty: "st",
                c: {
                  a: 0,
                  k: [
                    0.596124387255,
                    0.505123721852,
                    0.401571236405,
                    1
                  ],
                  ix: 3
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 4
                },
                w: {
                  a: 0,
                  k: 14,
                  ix: 5
                },
                lc: 1,
                lj: 1,
                ml: 4,
                ml2: {
                  a: 0,
                  k: 4,
                  ix: 8
                },
                nm: "Stroke 1",
                mn: "ADBE Vector Graphic - Stroke",
                hd: false
              },
              {
                ty: "fl",
                c: {
                  a: 0,
                  k: [
                    0.22981004902,
                    0.22981004902,
                    0.22981004902,
                    1
                  ],
                  ix: 4
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 5
                },
                r: 1,
                nm: "Fill 1",
                mn: "ADBE Vector Graphic - Fill",
                hd: true
              },
              {
                ty: "tr",
                p: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 2
                },
                a: {
                  a: 0,
                  k: [
                    0,
                    0
                  ],
                  ix: 1
                },
                s: {
                  a: 0,
                  k: [
                    100,
                    100
                  ],
                  ix: 3
                },
                r: {
                  a: 0,
                  k: 0,
                  ix: 6
                },
                o: {
                  a: 0,
                  k: 100,
                  ix: 7
                },
                sk: {
                  a: 0,
                  k: 0,
                  ix: 4
                },
                sa: {
                  a: 0,
                  k: 0,
                  ix: 5
                },
                nm: "Transform"
              }
            ],
            nm: "Shape 1",
            np: 3,
            cix: 2,
            ix: 1,
            mn: "ADBE Vector Group",
            hd: false
          }
        ],
        ip: 0,
        op: 4502,
        st: 0,
        bm: 0
      }
    ]
  }
];
const layers = [
  {
    ddd: 0,
    ind: 1,
    ty: 4,
    nm: "Shape Layer 6",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          540,
          526,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "rc",
            d: 1,
            s: {
              a: 0,
              k: [
                589.805,
                394.385
              ],
              ix: 2
            },
            p: {
              a: 0,
              k: [
                -222,
                -20
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 51,
              ix: 4
            },
            nm: "Rectangle Path 1",
            mn: "ADBE Vector Shape - Rect",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.862745098039,
                0,
                0.196078431373,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 43,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.15162377451,
                0.15162377451,
                0.15162377451,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                242.055,
                -286.34
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Rectangle 1",
        np: 3,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 4003,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 2,
    ty: 4,
    nm: "Shape Layer 10",
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "sr",
            sy: 2,
            d: 1,
            pt: {
              a: 0,
              k: 6,
              ix: 3
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 4
            },
            r: {
              a: 0,
              k: 0,
              ix: 5
            },
            or: {
              a: 0,
              k: 540,
              ix: 7
            },
            os: {
              a: 0,
              k: 0,
              ix: 9
            },
            ix: 1,
            nm: "Polystar Path 1",
            mn: "ADBE Vector Shape - Star",
            hd: false
          },
          {
            ty: "rd",
            nm: "Round Corners 1",
            r: {
              a: 0,
              k: 10,
              ix: 1
            },
            ix: 2,
            mn: "ADBE Vector Filter - RC",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.862745098039,
                0,
                0.196078431373,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 0,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.332425614899,
                0.483094488406,
                0.592463235294,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Polystar 1",
        np: 4,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 175,
    op: 250,
    st: 175,
    bm: 0
  },
  {
    ddd: 0,
    ind: 3,
    ty: 0,
    nm: "MAIN FRAME 3",
    tt: 1,
    refId: "comp_0",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    w: 1080,
    h: 1080,
    ip: 175,
    op: 250,
    st: 175,
    bm: 0
  },
  {
    ddd: 0,
    ind: 4,
    ty: 4,
    nm: "Shape Layer 9",
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "sr",
            sy: 2,
            d: 1,
            pt: {
              a: 0,
              k: 6,
              ix: 3
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 4
            },
            r: {
              a: 0,
              k: 0,
              ix: 5
            },
            or: {
              a: 0,
              k: 540,
              ix: 7
            },
            os: {
              a: 0,
              k: 0,
              ix: 9
            },
            ix: 1,
            nm: "Polystar Path 1",
            mn: "ADBE Vector Shape - Star",
            hd: false
          },
          {
            ty: "rd",
            nm: "Round Corners 1",
            r: {
              a: 0,
              k: 10,
              ix: 1
            },
            ix: 2,
            mn: "ADBE Vector Filter - RC",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.862745098039,
                0,
                0.196078431373,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 0,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.332425614899,
                0.483094488406,
                0.592463235294,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Polystar 1",
        np: 4,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 125,
    op: 175,
    st: 125,
    bm: 0
  },
  {
    ddd: 0,
    ind: 5,
    ty: 0,
    nm: "MAIN FRAME",
    tt: 1,
    refId: "comp_11",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    w: 1080,
    h: 1080,
    ip: 125,
    op: 175,
    st: 125,
    bm: 0
  },
  {
    ddd: 0,
    ind: 6,
    ty: 4,
    nm: "Shape Layer 8",
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "sr",
            sy: 2,
            d: 1,
            pt: {
              a: 0,
              k: 6,
              ix: 3
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 4
            },
            r: {
              a: 0,
              k: 0,
              ix: 5
            },
            or: {
              a: 0,
              k: 540,
              ix: 7
            },
            os: {
              a: 0,
              k: 0,
              ix: 9
            },
            ix: 1,
            nm: "Polystar Path 1",
            mn: "ADBE Vector Shape - Star",
            hd: false
          },
          {
            ty: "rd",
            nm: "Round Corners 1",
            r: {
              a: 0,
              k: 10,
              ix: 1
            },
            ix: 2,
            mn: "ADBE Vector Filter - RC",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.862745098039,
                0,
                0.196078431373,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 0,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.332425614899,
                0.483094488406,
                0.592463235294,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Polystar 1",
        np: 4,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 50,
    op: 125,
    st: 50,
    bm: 0
  },
  {
    ddd: 0,
    ind: 7,
    ty: 0,
    nm: "MAIN FRAME 2",
    tt: 1,
    refId: "comp_12",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    w: 1080,
    h: 1080,
    ip: 50,
    op: 126,
    st: 50,
    bm: 0
  },
  {
    ddd: 0,
    ind: 8,
    ty: 4,
    nm: "Shape Layer 1",
    td: 1,
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "sr",
            sy: 2,
            d: 1,
            pt: {
              a: 0,
              k: 6,
              ix: 3
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 4
            },
            r: {
              a: 0,
              k: 0,
              ix: 5
            },
            or: {
              a: 0,
              k: 540,
              ix: 7
            },
            os: {
              a: 0,
              k: 0,
              ix: 9
            },
            ix: 1,
            nm: "Polystar Path 1",
            mn: "ADBE Vector Shape - Star",
            hd: false
          },
          {
            ty: "rd",
            nm: "Round Corners 1",
            r: {
              a: 0,
              k: 10,
              ix: 1
            },
            ix: 2,
            mn: "ADBE Vector Filter - RC",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.862745098039,
                0,
                0.196078431373,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 0,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.332425614899,
                0.483094488406,
                0.592463235294,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Polystar 1",
        np: 4,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 50,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 9,
    ty: 0,
    nm: "MAIN FRAME",
    tt: 1,
    refId: "comp_11",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    w: 1080,
    h: 1080,
    ip: 0,
    op: 50,
    st: 0,
    bm: 0
  },
  {
    ddd: 0,
    ind: 10,
    ty: 4,
    nm: "Shape Layer 7",
    sr: 1,
    ks: {
      o: {
        a: 0,
        k: 100,
        ix: 11
      },
      r: {
        a: 0,
        k: 0,
        ix: 10
      },
      p: {
        a: 0,
        k: [
          540,
          540,
          0
        ],
        ix: 2
      },
      a: {
        a: 0,
        k: [
          0,
          0,
          0
        ],
        ix: 1
      },
      s: {
        a: 0,
        k: [
          100,
          100,
          100
        ],
        ix: 6
      }
    },
    ao: 0,
    shapes: [
      {
        ty: "gr",
        it: [
          {
            ty: "sr",
            sy: 2,
            d: 1,
            pt: {
              a: 0,
              k: 6,
              ix: 3
            },
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 4
            },
            r: {
              a: 0,
              k: 0,
              ix: 5
            },
            or: {
              a: 0,
              k: 540,
              ix: 7
            },
            os: {
              a: 0,
              k: 0,
              ix: 9
            },
            ix: 1,
            nm: "Polystar Path 1",
            mn: "ADBE Vector Shape - Star",
            hd: false
          },
          {
            ty: "rd",
            nm: "Round Corners 1",
            r: {
              a: 0,
              k: 10,
              ix: 1
            },
            ix: 2,
            mn: "ADBE Vector Filter - RC",
            hd: false
          },
          {
            ty: "st",
            c: {
              a: 0,
              k: [
                0.4,
                0.4,
                0.4,
                1
              ],
              ix: 3
            },
            o: {
              a: 0,
              k: 100,
              ix: 4
            },
            w: {
              a: 0,
              k: 9,
              ix: 5
            },
            lc: 1,
            lj: 1,
            ml: 4,
            ml2: {
              a: 0,
              k: 4,
              ix: 8
            },
            nm: "Stroke 1",
            mn: "ADBE Vector Graphic - Stroke",
            hd: false
          },
          {
            ty: "fl",
            c: {
              a: 0,
              k: [
                0.332425614899,
                0.483094488406,
                0.592463235294,
                1
              ],
              ix: 4
            },
            o: {
              a: 0,
              k: 100,
              ix: 5
            },
            r: 1,
            nm: "Fill 1",
            mn: "ADBE Vector Graphic - Fill",
            hd: false
          },
          {
            ty: "tr",
            p: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 2
            },
            a: {
              a: 0,
              k: [
                0,
                0
              ],
              ix: 1
            },
            s: {
              a: 0,
              k: [
                100,
                100
              ],
              ix: 3
            },
            r: {
              a: 0,
              k: 0,
              ix: 6
            },
            o: {
              a: 0,
              k: 100,
              ix: 7
            },
            sk: {
              a: 0,
              k: 0,
              ix: 4
            },
            sa: {
              a: 0,
              k: 0,
              ix: 5
            },
            nm: "Transform"
          }
        ],
        nm: "Polystar 1",
        np: 4,
        cix: 2,
        ix: 1,
        mn: "ADBE Vector Group",
        hd: false
      }
    ],
    ip: 0,
    op: 4502,
    st: 0,
    bm: 0
  }
];
const markers = [];
const animationData = {
  v,
  fr,
  ip,
  op,
  w,
  h,
  nm,
  ddd,
  assets,
  layers,
  markers
};
export {
  assets,
  ddd,
  animationData as default,
  fr,
  h,
  ip,
  layers,
  markers,
  nm,
  op,
  v,
  w
};
//# sourceMappingURL=queue-animation.json.js.map
